import { render, staticRenderFns } from "./visitInquiry.vue?vue&type=template&id=1934c39e&scoped=true&"
import script from "./visitInquiry.vue?vue&type=script&lang=js&"
export * from "./visitInquiry.vue?vue&type=script&lang=js&"
import style0 from "./visitInquiry.vue?vue&type=style&index=0&id=1934c39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934c39e",
  null
  
)

export default component.exports